import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {OwnershipTransferCustomerStep} from './Constant/Constant';
import {OwnershipTransferActionType} from '../OwnershipTransferBlock/Constant/Constant';
import {
  setCurrentStep,
  setShowPopUp,
  saveToHistory,
  resetState,
  customerValidation,
  setCustomerData,
  idNumberAndCCValidation,
} from './OwnershipTransferCustomerSlice';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import Popup from '../../Shared/Popup/PopUp';
import OwnershipTransferCustomerPopup from './Popups/OwnershipTransferCustomerPopup';
import GeneralMessage from '../OwnershipTransferBlock/Steps/GeneralMessage';
import SelectPackage from './Steps/SelectPackage';
import Obligations from './Steps/Obligations';
import CustomerForm from './Steps/CustomerForm';
import CustomerAddress from './Steps/CustomerAddress';
import CellcomDu from './Steps/CellcomDu';
import CustomerPaymentMethod from './Steps/CustomerPaymentMethod';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';
import {getRecaptchaToken} from '../../../utilities/recaptcha/recaptcha';
import {transferOption} from 'app/Components/Block/TransferOrganizationAccountBlock/Constant/Constant';

const OwnershipTransferCustomer = (props) => {
  useEffect(() => {
    return () => {
      props.resetState();
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [props.data.currentStep]);

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        start();
      }
    },
    [props.authentication],
  );

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects() && props.data.customerValidated) {
        props.idNumberAndCCValidation(props.data.requestId);
      }
    },
    [props.data.customerValidated],
  );

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      props.saveToHistory(props.data.currentStep);
    }, 3000);

    return () => clearTimeout(timeoutId); // Cleanup to prevent memory leaks
  }, [props.data.currentStep, props.data.signatureFile]);

  function start() {
    if (props.authentication.isAuthenticateFinish) {
      const customerData = {
        phoneNumber: props.authentication.loginData.magicLinkParameters?.phoneNumber,
        orgId: props.authentication.loginData.magicLinkParameters?.orgId,
        idNumber: props.authentication.loginData.magicLinkParameters?.idNumber,
      };
      props.setCustomerData(customerData);
      //validate customer
      const req = {
        OrgId: props.authentication.loginData.magicLinkParameters?.orgId,
        //ActionType: OwnershipTransferActionType.BusinessToPrivate,
        SubscriberPhoneNumber: props.authentication.loginData.magicLinkParameters?.phoneNumber,
      };

      props.customerValidation(req);
    } else {
      props.showAppLoader();
    }
  }

  let getCurrentStep = () => {
    switch (props.data.currentStep) {
      case OwnershipTransferCustomerStep.SelectPackage:
        return <SelectPackage iContent={props.iContent} />;
      case OwnershipTransferCustomerStep.EquipmentObligations:
        return <Obligations />;
      case OwnershipTransferCustomerStep.SubscriberPersonalData:
        return <CustomerForm />;
      case OwnershipTransferCustomerStep.CellcomDu:
        return <CellcomDu />;
      case OwnershipTransferCustomerStep.AddressForm:
        return <CustomerAddress />;
      case OwnershipTransferCustomerStep.CustomerPaymentMethod:
        return <CustomerPaymentMethod />;
      case OwnershipTransferCustomerStep.GeneralMessage:
        return (
          <GeneralMessage
            messageData={props.data.generalMessage}
            data={props.data}
            isNewLineAction={props.data.selectedTransferOption === transferOption.newLine}
          />
        );
      default:
        break;
    }
  };
  useClearStateResetFlag();
  return (
    <div className='ownershipTransfer'>
      {getCurrentStep()}
      <Popup className={`${props.data.currentPopUp} mainPopup`} showPopUp={props.data.showPopup} onClose={() => props.setShowPopUp(false)}>
        <OwnershipTransferCustomerPopup />
      </Popup>
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.OwnershipTransferCustomer,
  authentication: state.authentication,
});

const mapDispatchToProps = {
  setShowPopUp,
  setCurrentStep,
  saveToHistory,
  showAppLoader,
  hideAppLoader,
  resetState,
  customerValidation,
  setCustomerData,
  idNumberAndCCValidation,
};

export default connect(mapStateToProps, mapDispatchToProps)(OwnershipTransferCustomer);
